import { Container, Stack } from "@mui/system";
import { Grid, Paper, Typography, Accordion, AccordionDetails, AccordionSummary } from "@mui/material";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import React from "react";
import globals from "../globals";

const questions = [
    {
        title: 'Как да се запиша за курс?',
        answer: 'Регистрирай се в eAcademiaBg, избери желания курс и натисни бутона „Запиши се“ или „Добави в количка“. След плащането ще получиш потвърждение и информация за урока'
    },
    {
        title: 'Какви методи на плащане приемате?',
        answer: 'Приемаме плащания с дебитни/кредитни карти през Stripe. Всички плащания са защитени чрез криптирана връзка.'
    },
    {
        title: 'Как се провеждат уроците?',
        answer: 'Уроците се провеждат изцяло онлайн чрез Zoom. Линк за достъп ще получиш в профила си преди уговорения час на урока, както и уведомление, че е направена среща по имейл.'
    },
    {
        title: ' Мога ли да сменя часа или датата на урока?',
        answer: 'Да, ако уведомиш преподавателя поне 24 часа предварително. При спешни случаи - най-късно 3 часа преди урока. Ако не уведомиш в този срок, урокът се счита за проведен.'
    },
    // {
    //     title: 'Как мога да стана преподавател?',
    //     answer: 'Посети секцията „Стани учител“, попълни формата и отговори на въпросите за опит и мотивация. Ще се свържем с теб, ако отговаряш на критериите.'
    // },
    {
        title: 'Имат ли курсовете записи?',
        answer: 'Да, нашите уроци се записват с цел контрол на качеството, а ти и можеш да гледаш записите в удобно за теб време'
    },
    {
        title: ' Какво да направя при технически проблем по време на урок?',
        answer: 'Опитай да презаредиш връзката или да влезеш отново в Zoom. Ако проблемът продължи, свържи се с нас чрез страницата „Контакти“, където ще намериш телефон и имейл за съдействие.'
    },

]


const ContactUsPage = () => {
    return (
        <Container>
            <Grid>
                <Paper sx={{ backgroundColor: globals.colors.darkBlue, width: '100%', borderRadius: 8 }}>
                    <Grid container justifyContent={'space-evenly'}>
                        <Grid display="flex" justifyContent="center" alignItems="center" size={{ xs: 10, md: 8 }} width={{ xs: 2, md: 0.3 }} justifySelf={'auto'} textAlign={'center'}>
                            <Typography sx={{ color: globals.colors.backgroundColor, fontWeight: "bold", alignSelf: "center", fontSize: 50 }}>Свържи се с eAcademiaBg</Typography>
                        </Grid>
                        <Grid display="flex" justifyContent="center" alignItems="center" size={{ xs: 10, md: 4 }} width={{ xs: 1, md: 0.3 }} justifySelf={'auto'} direction={'column'}>
                            <img style={{ overflow: 'hidden', maxWidth: "100%", height: "auto" }} src='contact_page_owl.webp' loading="lazy" decoding="async" />
                        </Grid>
                    </Grid>
                </Paper>
            </Grid>

            <Grid container justifyContent="space-evenly" alignItems="center" sx={{ textAlign: 'center', mt: 5 }} spacing={5}>
                <Grid item xs={12} sm={6} md={4} textAlign={'start'}>
                    {/* email doesnt work */}
                    <Typography sx={{ fontSize: 20, color: globals.colors.darkBlue, fontWeight: 'bold' }}>Имейл: <a href="mailto:info@eacademiabg.com" style={{ color: globals.colors.lightRed }}>info@eacademiabg.com</a></Typography>
                    <Typography sx={{ fontSize: 20, color: globals.colors.darkBlue, fontWeight: 'bold', mt: 2 }}>Телефон: <a href="tel:+359878852548" style={{ color: globals.colors.lightRed }}>+359 87 885 2548</a></Typography>
                </Grid>
                <Grid item xs={12} sm={6} >
                    <Typography sx={{ fontSize: 20, color: globals.colors.darkBlue, fontWeight: 'bold' }}>Последвай ни в социалните мрежи:</Typography>
                    <Grid container justifyContent={'center'} alignItems={'center'} >
                        <Grid item xs={2}>
                            <a href='https://www.facebook.com/eacademiabg'><img src='facebook_logo.webp' loading="lazy" decoding="async" style={{ height: 80, width: 80 }} /></a>
                        </Grid>
                        <Grid item xs={2}>
                            <a href='https://www.instagram.com/eacademiabg/'><img src='instagram_logo.webp' loading="lazy" decoding="async" style={{ height: 80, width: 80 }} /></a>
                        </Grid>
                        <Grid item xs={2}>
                            <a href='https://www.youtube.com/@eacademiabg8334'><img src='youtube_logo.webp' loading="lazy" decoding="async" style={{ height: 80, width: 80 }} /></a>
                        </Grid>
                        <Grid item xs={2}>
                            <a href='https://www.tiktok.com/@eacademiabg'><img src='tiktok_logo.webp' loading="lazy" decoding="async" style={{ height: 80, width: 80 }} /></a>
                        </Grid>
                        <Grid item xs={2}>
                            <a href='https://www.linkedin.com/company/eacademiabg'><img src='linkedin_logo.webp' loading="lazy" decoding="async" style={{ height: 80, width: 80 }} /></a>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>

            <Grid container justifyContent={'center'} textAlign={'center'} sx={{ mt: 10 }}>
                <Grid item>
                    <Typography sx={{ color: globals.colors.darkBlue, fontSize: 30, fontWeight: 'bold' }}>Често задавани въпроси (FAQ)</Typography>
                </Grid>
                <Grid container textAlign={'left'} sx={{ mt: 3 }} spacing={1}>
                    <Grid item sm={12} xs={12}>
                        <Accordion>
                            <AccordionSummary
                                expandIcon={<ExpandMoreIcon />}
                            >
                                <Typography sx={{ color: globals.colors.darkBlue, fontWeight: 'bold', fontSize: 20 }}>
                                    Как да се запиша за курс?
                                </Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                                Регистрирай се в eAcademiaBg, избери желания курс и натисни бутона <strong>„Заяви опознавателна среща“</strong> или <strong>„Добавяне в количка“</strong>.
                                „Добавяне в количка“ води до страница за плащане и избиране на удобен час. Можеш и да заявиш <strong>напълно безплатно</strong> опознавателна среща с учителя, за да зададеш въпроси или просто да се запознаете.
                            </AccordionDetails>
                        </Accordion>
                    </Grid>
                    <Grid item sm={12} xs={12}>
                        <Accordion>
                            <AccordionSummary
                                expandIcon={<ExpandMoreIcon />}
                            >
                                <Typography sx={{ color: globals.colors.darkBlue, fontWeight: 'bold', fontSize: 20 }}>
                                    Какви методи на плащане приемате?
                                </Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                                Приемаме плащания с дебитни/кредитни карти през Stripe. Всички плащания са защитени чрез криптирана връзка.
                            </AccordionDetails>
                        </Accordion>
                    </Grid>
                    <Grid item sm={12} xs={12}>
                        <Accordion>
                            <AccordionSummary
                                expandIcon={<ExpandMoreIcon />}
                            >
                                <Typography sx={{ color: globals.colors.darkBlue, fontWeight: 'bold', fontSize: 20 }}>
                                    Как се провеждат уроците?
                                </Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                                Уроците се провеждат изцяло онлайн чрез Zoom. Линк за достъп ще получиш в профила си преди
                                уговорения час на урока, както и уведомление, че е направена среща по имейл.
                            </AccordionDetails>
                        </Accordion>
                    </Grid>
                    <Grid item sm={12} xs={12}>
                        <Accordion>
                            <AccordionSummary
                                expandIcon={<ExpandMoreIcon />}
                            >
                                <Typography sx={{ color: globals.colors.darkBlue, fontWeight: 'bold', fontSize: 20 }}>
                                    Мога ли да сменя часа или датата на урока?
                                </Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                                Да, ако уведомиш преподавателя поне 24 часа предварително. При спешни случаи -
                                най-късно 3 часа преди урока. Ако не уведомиш в този срок, урокът се счита за проведен.

                            </AccordionDetails>
                        </Accordion>
                    </Grid>
                    <Grid item sm={12} xs={12}>
                        <Accordion>
                            <AccordionSummary
                                expandIcon={<ExpandMoreIcon />}
                            >
                                <Typography sx={{ color: globals.colors.darkBlue, fontWeight: 'bold', fontSize: 20 }}>
                                    Мога ли да си върна парите?
                                </Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                                <>
                                    <Typography>Да, при определени условия:</Typography>
                                    <ul>
                                        <li>Можеш да поискаш възстановяване до <strong>7 дни</strong> след покупката <strong>и само ако първият урок не е започнал</strong>.</li>
                                        <li>

                                            Ако урок не се проведе по вина на преподавателя, имаш право на пълно възстановяване или безплатен заместител.
                                            Подробности са описани в нашата <a href='/refund-policy'>Политика за възстановяване на суми (Refund Policy)</a>. За подаване на заявка или въпроси отиди в менюто раздел <strong>„Контакти“</strong> - там ще намериш телефоните и имейла ни.</li>
                                    </ul>
                                </>
                            </AccordionDetails>
                        </Accordion>
                    </Grid>
                    {/* <Grid item sm={12} xs={12}>
                        <Accordion>
                            <AccordionSummary
                                expandIcon={<ExpandMoreIcon />}
                            >
                                <Typography sx={{ color: globals.colors.darkBlue, fontWeight: 'bold', fontSize: 20 }}>
                                    Как мога да стана преподавател?
                                </Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                                Посети секцията <strong>„Стани учител“</strong>, попълни формата и отговори на въпросите за опит и мотивация. Ще се свържем с теб, ако отговаряш на критериите.
                            </AccordionDetails>
                        </Accordion>
                    </Grid> */}
                    <Grid item sm={12} xs={12}>
                        <Accordion>
                            <AccordionSummary
                                expandIcon={<ExpandMoreIcon />}
                            >
                                <Typography sx={{ color: globals.colors.darkBlue, fontWeight: 'bold', fontSize: 20 }}>
                                    Има ли записи на курсовете?
                                </Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                                Да, нашите уроци се записват с цел контрол на качеството, а ти и можеш да гледаш записите в удобно за теб време, след като ни пишеш отделно за тях.
                            </AccordionDetails>
                        </Accordion>
                    </Grid>
                    <Grid item sm={12} xs={12}>
                        <Accordion>
                            <AccordionSummary
                                expandIcon={<ExpandMoreIcon />}
                            >
                                <Typography sx={{ color: globals.colors.darkBlue, fontWeight: 'bold', fontSize: 20 }}>
                                    Какво да направя при технически проблем по време на урок?
                                </Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                                Опитай да презаредиш връзката или да влезеш отново в Zoom. Ако проблемът продължи, свържи се с нас чрез <strong>страницата „Контакти“</strong>, където ще намериш телефон и имейл за съдействие
                            </AccordionDetails>
                        </Accordion>
                    </Grid>
                </Grid>
            </Grid>
        </Container>
    );
}

export default ContactUsPage;